const dashboardQuery = `query Query(
  $newAndOutstandingQuestionInput: NewAndOutstandingQuestionsInput!
  $companyIdOnlyInput: CompanyIdOnlyInput!
  $announcementListInput: AnnouncementListInput!
  $teamMembersListInput: TeamMemberListInput!
  $eventsListInput: EventListInput!
  $onboardingChecklistDataInput:CompanyIdInput!
) {
  newAndTotalOutstandingQuestions(
    newAndOutstandingQuestionInput: $newAndOutstandingQuestionInput
  ) {
    totalNewQuestions
    totalOutstandingQuestions
  }
  getTotalInterestedAndInvestedInvestor(
    CompanyIdOnlyInput: $companyIdOnlyInput
  ) {
    totalInterestedInvestor
    totalInvestedInvestor
    changedPercentageMonthly
  }
  getCompanyAnnouncements(announcementListInput: $announcementListInput) {
    items {
      title
      seenPercentage
      announcementId
      publishedDate
      totalViews
      _id
    }
  }
  getTeamMembers(teamMembersListInput: $teamMembersListInput) {
    items {
      teamMember {
        _id
        jobTitle
        profileImage
      }
    }
    meta {
      totalItems
    }
  }
  getCompanyEvents(eventsListInput: $eventsListInput) {
    items {
      _id
      allDay
      attachment
      companyId
      date
      deleted
      description
      endTime
      eventAttendies
      isHoliday
      location
      publishedDate
      startTime
      title
      userId
    }
  }
  getOnboardingChecklistData(onboardingChecklistDataInput: $onboardingChecklistDataInput) {
      addCompanyBio
      addCompanyLogo
      addExecutive
      addFAQ
      completionTime
      inviteInvestors
      showOnboardingChecklist
    }
}`;
const dashboardQuery2 = `query Query(
  $newAndOutstandingQuestionInput: NewAndOutstandingQuestionsInput!
  $companyIdOnlyInput: CompanyIdOnlyInput!
  $announcementListInput: AnnouncementListInput!
  $teamMembersListInput: TeamMemberListInput!
  $eventsListInput: EventListInput!
) {
  
  newAndTotalOutstandingQuestions(
    newAndOutstandingQuestionInput: $newAndOutstandingQuestionInput
  ) {
    totalNewQuestions
    totalOutstandingQuestions
  }
  getTotalInterestedAndInvestedInvestor(
    CompanyIdOnlyInput: $companyIdOnlyInput
  ) {
    totalInterestedInvestor
    totalInvestedInvestor
  }
  getCompanyAnnouncements(announcementListInput: $announcementListInput) {
    items {
      title
      seenPercentage
      announcementId
      publishedDate
      totalViews
      _id
    }
  }
  getTeamMembers(teamMembersListInput: $teamMembersListInput) {
    items {
      teamMember {
        _id
        jobTitle
        profileImage
      }
    }
    meta {
      totalItems
    }
  }
  getCompanyEvents(eventsListInput: $eventsListInput) {
    items {
      _id
      allDay
      attachment
      companyId
      date
      deleted
      description
      endTime
      eventAttendies
      isHoliday
      location
      publishedDate
      startTime
      title
      userId
    }
  }
}`;
const questionsQuery = `query Query(
  $enquiryListInput: EnquiryQuestionListInput!
  $enquiryCategoryListInput: EnquiryCategoryListInput!
  $teamMembersListInput: TeamMemberListInput!
  $companyId: String!
) {
  getEnquiryQuestions(enquiryListInput: $enquiryListInput) {
    items {
      _id
      assignedTo
      assigneeName
      archivedBy
      audio
      companyId
      createdAt
      enquiryCategoryId
      enquiryCategoryName
      investorId
      question
      resolvedBy
      status
      subject
      rating
      addedToRegistry
      investor {
        investorStatus
        _id
        email
        firstName
        lastName
      }
    }
    meta {
      currentPage
      itemCount
      itemsPerPage
      totalItems
      totalItems
    }
  }
  getEnquiryCategories(enquiryCategoryListInput: $enquiryCategoryListInput) {
    items {
            hoverCategoryColor
                    createdBy
                    companyId
                    categoryColor
                    _id
                    name
                    textColor
    }
  }
  getTeamMembersWithQuestionPermission(teamMembersListInput: $teamMembersListInput) {
    _id
    lastName
    userName
    firstName
    companyCreator
  }
  getTotalUnreadQuestions(companyId: $companyId) {
    total
  }
}`;
const faqQuery = `query Query($companyId: String!) {
    listFaqCategoryWithFaqs(companyId: $companyId) {
      _id
      categoryName
      displayOrder
      faqs {
        _id
        answer
        displayOrder
        faqCategoryId
        question
      }
    }
}`;
const companyQuery = `query Query {
    userCompanyList {
      _id
      legalBusinessName
      companyLogo
    }
}`;
const loginQuery = `mutation($loginUserInput: LoginUserInput!) {
    userLogin(loginUserInput: $loginUserInput) {
      token {
        accessToken
        refreshToken
      }
      user {
        _id
        verifiedAt
        email
        lastLoggedInAt
      }
      companyId
      inCompany
    }
}`;
const googleLoginQuery = `mutation LoginWithGoogle($googleToken: GoogleLoginInput!) {
  loginWithGoogle(googleToken: $googleToken) {
    otpData {
      message
      otpExpiresAt
    }
    userData {
      companyId
      inCompany
      user {
        _id
        acceptedEmailCommunication
        acceptedTAndC
        companyCreator
        email
        firstName
        jobTitle
        lastLoggedInAt
        lastName
        mobileNum
        plan
        profileImage
        receiveNotification
        registeredWithGoogle
        stripeCustomerId
        subscriptionRenewable
        subscriptionStatus
        userName
        verifiedAt
      }
      token {
        accessToken
        accessTokenExpiresIn
        refreshToken
        refreshTokenExpiresIn
      }
    }
  }
}`;
const verifyQuery = `mutation Mutation($verifyEmailOtpInput: VerifyEmailOtpInput!) {
    verifyEmailOtp(verifyEmailOtpInput: $verifyEmailOtpInput) {
      _id
    }
}`;
const registerQuery = `mutation RegisterUser($userRegisterInput: UserRegisterInput!) {
    registerUser(userRegisterInput: $userRegisterInput) {
      token {
        accessToken
        refreshToken
        accessTokenExpiresIn
        refreshTokenExpiresIn
      }
      user {
        _id
        email
      }
      otpExpiresAt
    }
}`;
const registerCompanyQuery = `mutation Mutation($createCompanyInput: CreateCompanyInput!) {
    registerCompany(createCompanyInput: $createCompanyInput) {
      company {
        _id
      },
      token {
        accessToken
        accessTokenExpiresIn
        refreshToken
        refreshTokenExpiresIn
      }
    }
}`;
const forgotPasswordQuery = `mutation UserForgotPassword($userEmailOnly: ForgetPasswordInput!) {
  userForgotPassword(userEmailOnly: $userEmailOnly) {
    message
  }
}`;
const resetPasswordQuery = `mutation Mutation($userResetPasswordInput: UserResetPasswordInput!) {
    userResetPassword(userResetPasswordInput: $userResetPasswordInput) {
      message
    }
}`;
const loggedInUserQuery = `query GetCompanyDetail($company: CompanyIdOnlyInput!, $companyId: String!) {
  getCompanyDetail(company: $company) {
    _id
    abn
    about
    addressLineOne
    addressLineTwo
    asxCode
    companyLogo
    disabled
    email
    legalBusinessName
    optionalBusinessName
    phoneNumber
    postCode
    state
    suburb
    userId
    validated
    verifiedAt
    websiteUrl
    companyCreator
    teamName
      permissions {
                userPermissions {
                    name
                    allowed
                    acessType
                }
                teamMemberRole
                hasAdministrativeControl
                canManageQuestion
                canInviteTeamMembers
                canCreateEvent
            }
    companyLinks{
       _id
      priorityOrder
      title
      type
      url
      locked
    }
    companyCreatorLastLoggedIn
    createdAt
    previousSubscription {
      endDate
      id
      plan
      quantity
      stripeCustomerId
    }
    subscription {
      activationDate
      endDate
      id
      plan
      startDate
      quantity
      status
      stripeCustomerId
      renewable
      hold
    }
    location {
      type
      coordinates
    }
    permissions {
                userPermissions {
                    name
                    allowed
                    acessType
                }
                teamMemberRole
                hasAdministrativeControl
                canManageQuestion
                canInviteTeamMembers
                canCreateEvent
            }
  }
  loggedInUserDetail {
    _id
    acceptedTAndC
    email
    firstName
    jobTitle
    lastLoggedInAt
    lastName
    mobileNum
    profileImage
    receiveNotification
    registeredWithGoogle
    userName
    verifiedAt
    stripeCustomerId
    subscriptionStatus
    plan
    hasViewedIntegrationModal
    hasClickedIntegrationButton
  }
  getTotalUnreadQuestions(companyId: $companyId) {
    total
  }
  userCompanyList {
    _id
    legalBusinessName
    companyLogo
    isLocked
  }
}`;
const updateProfileQuery = `mutation UpdateUserProfile($updateProfileInput: UpdateProfileInput!) {
  updateUserProfile(updateProfileInput: $updateProfileInput) {
    _id
    acceptedTAndC
    email
    firstName
    jobTitle
    lastLoggedInAt
    lastName
    mobileNum
    profileImage
    receiveNotification
    registeredWithGoogle
    userName
    verifiedAt
  }
}`;
const updateProfileImage = ` mutation UpdateUserProfileImage($updateProfileImageInput: UpdateProfileImageInput!) {
        updateUserProfileImage(updateProfileImageInput: $updateProfileImageInput) {
            _id
            acceptedEmailCommunication
            acceptedTAndC
            companyCreator
            email
            emailChangedTime
            acceptedWelcomeEmail
            firstName
            hasClickedIntegrationButton
            hasViewedIntegrationModal
            hasViewedQuickResponseInfo
            jobTitle
            lastLoggedInAt
            lastName
            plan
            mobileNum
            profileImage
            receiveNotification
            registeredWithGoogle
            stripeCustomerId
            subscriptionRenewable
            subscriptionStatus
            userName
            verifiedAt
        }
    }`;
const updateProfilePicture = `mutation UploadProfileImage($file: Upload!) { uploadProfileImage(file: $file) { key } }`;
const getImage = `query GetSignedUrlFromKey($key: String!) {
  getSignedUrlFromKey(key: $key) {
    signedUrl
  }
}`;
const getCompanyDetails = `query GetCompanyDetail($company: CompanyIdOnlyInput!) {
  getCompanyDetail(company: $company) {
    _id
    abn
    about
    addressLineOne
    addressLineTwo
    asxCode
    companyLogo
    disabled
    email
    legalBusinessName
    optionalBusinessName
    phoneNumber
    postCode
    state
    suburb
    userId
    validated
    verifiedAt
    websiteUrl
    companyLinks{
       _id
      priorityOrder
      title
      type
      url
      locked
    }
    location {
      type
      coordinates
    }
  }
}`;
const uploadCompanyLogo = `mutation UploadCompanyLogo($file: Upload!) {
  uploadCompanyLogo(file: $file) {
    key
  }
}`;
const updateCompanyQuery = `mutation UpdateCompany($updateCompanyInput: UpdateCompanyInput!) {
  updateCompany(updateCompanyInput: $updateCompanyInput) {
    _id
    abn
    about
    addressLineOne
    addressLineTwo
    asxCode
    companyLogo
    disabled
    email
    legalBusinessName
    location {
      coordinates
      type
    }  
    companyLinks{
       _id
      priorityOrder
      title
      type
      url
      locked
    }
    optionalBusinessName
    phoneNumber
    postCode
    suburb
    state
    userId
    validated
    verifiedAt
    websiteUrl
  }
}`;
const updateCompanyLogoQuery = `mutation UpdateCompanyLogo($updateCompanyLogoInput: UpdateCompanyLogoInput!) {
  updateCompanyLogo(updateCompanyLogoInput: $updateCompanyLogoInput) {
    companyLogo
  }
}`;
const announcementList = `query GetCompanyAnnouncements($announcementListInput: AnnouncementListInput!, $companyId: IdOnly!) {
  getCompanyAnnouncements(announcementListInput: $announcementListInput) {
    items {
      _id
      announcementId
      announcementType
      asxCode
      attachment
      attachmentDuration
      attachmentSize
      attachmentThumbnail
      attachmentTotalPages
      companyId
      createdAt
      deleted
      fromAsx
      isPinned
      media
      pollInfoData {
        durationDays
        durationHours
        durationMinutes
        audienceType
        pollOptionsData {
          id
          option
          voteCount
        }
        remainingPollTime
        title
        totalVotes
        userVotes {
          firstName
          choosenOption
          investorType
          lastName
          createdAt
        }
      }
      publishedDate
      seenPercentage
      starred
      status
      title
      totalViews
      userId
    }
    meta {
      currentPage
      itemCount
      itemsPerPage
      totalItems
      totalPages
    }
  }
  getDraftAnnouncementCount(companyId: $companyId) {
    totalDrafts
  }
}`;
const starAnnouncement = `mutation StarAnnouncement($starAnnouncementInput: AnnouncementStarInput!) {
  starAnnouncement(starAnnouncementInput: $starAnnouncementInput) {
    _id
    attachment
    attachmentSize
    attachmentTotalPages
    companyId
    deleted
    fromAsx
    media
    publishedDate
    starred
    status
    title
    userId
    announcementSeenBy {
      seenAt
      investorId
    }
  }
}`;
const uploadAnnouncementFile = `mutation UploadAnnouncementFile($file: Upload!) {
  uploadAnnouncementFile(file: $file) {
    key
    thumbnailKey
    attachmentDuration
  }
}`;
const createAnnouncements = `mutation CreateAnnouncement($announcementInput: AnnouncementInput!) { createAnnouncement(announcementInput: $announcementInput) { _id } }`;
const softDeleteAnnouncements = `mutation SoftDeleteAnnouncement($announcementInput: AnnouncementDeleteInput!) {
  softDeleteAnnouncement(announcementInput: $announcementInput) {
    _id
  }
}`;
const deleteAnouncement = `mutation DeleteAnnouncement($announcementInput: AnnouncementDeleteInput!) {
  deleteAnnouncement(announcementInput: $announcementInput) {
    _id
  }
}`;
const getAnnouncementDetail = `query GetCompanyAnnouncement($announcementInput: AnnouncementDetailInput!) {
  getCompanyAnnouncement(announcementInput: $announcementInput) {
    _id
    announcementId
    asxCode
    announcementType
    attachment
    attachmentDuration
    attachmentSize
    attachmentThumbnail
    attachmentTotalPages
    companyId
    createdAt
    deleted
    fromAsx
    isPinned
    media
    pollInfoData {
      durationDays
      durationHours
      durationMinutes
      audienceType
      pollOptionsData {
        id
        option
        voteCount
      }
      remainingPollTime
      title
      totalVotes
      userVotes {
        choosenOption
        firstName
        investorType
        lastName
        createdAt
      }
    }
    publishedDate
    seenPercentage
    starred
    status
    title
    totalViews
    userId
  }
}`;
const updateAnnouncementDetail = `mutation UpdateAnnouncement($announcementInput: AnnouncementEditInput!) {
  updateAnnouncement(announcementInput: $announcementInput) {
    attachment
    _id
    attachmentSize
    attachmentTotalPages
    companyId
    createdAt
    deleted
    fromAsx
    media
    publishedDate
    seenPercentage
    starred
    status
    title
    userId
  }
}`;
const getActivities = `query GetActivities($activitiesListInput: ActivityListInput!) {
  getActivities(activitiesListInput: $activitiesListInput) {
    items {
      userId
      profileImage
      jobTitle
      _id
      activityDescription
      companyId
      createdAt
    }
    meta {
      currentPage
      itemCount
      itemsPerPage
      totalItems
      totalPages
    }
  }
}`;
const sendContactMessage = `mutation SendMessageToDiolog($contactUs: CreateContactUsDto!) {
  sendMessageToDiolog(contactUs: $contactUs) {
    _id
    message
    subject
  }
}`;
const getResponseTemplatesList = `query GetResponseTemplatesList($responseTemplateListInput: ResponseTemplateListInput!) {
  getResponseTemplatesList(responseTemplateListInput: $responseTemplateListInput) {
    items {
      _id
      attachments
      companyId
      content
      deleted
      starred
      title
      updatedAt
    }
    meta {
      totalPages
      totalItems
      itemsPerPage
      itemCount
      currentPage
    }
  }
}`;
const getLastOtpSent = `mutation GetLastOtpSent {
  getLastOtpSent {
    email
    expiresAt
  }
}`;
const starResponseTemplate = `mutation StarResponseTemplate($responseTemplateStarInput: ResponseTemplateStarInput!) {
  starResponseTemplate(responseTemplateStarInput: $responseTemplateStarInput) {
    _id
    attachments
    companyId
    content
    deleted
    starred
    title
    updatedAt
  }
}`;
const createResponseTemplate = `mutation CreateResponseTemplate($responseTemplateInput: ResponseTemplateInput!) {
  createResponseTemplate(responseTemplateInput: $responseTemplateInput) {
    attachments
    _id
    companyId
    content
    starred
    deleted
    title
    updatedAt
  }
}`;
const uploadTemplateFile = `mutation UploadResponseTemplateAttachment($file: Upload!) {
  uploadResponseTemplateAttachment(file: $file) {
    key
  }
}`;
const updateResponseTemplate = `mutation UpdateResponseTemplate($responseTemplateEditInput: ResponseTemplateEditInput!) {
  updateResponseTemplate(responseTemplateEditInput: $responseTemplateEditInput) {
    _id
    attachments
    companyId
    content
    deleted
    starred
    title
    updatedAt
  }
}`;
const getEnquiryDetail = `query GetCompanyEvent($enquiryDetailInput: EnquiryDetailInput!) {
  getEnquiryQuestion(enquiryDetailInput: $enquiryDetailInput) {
    _id
    archivedBy
    audio
    companyId
    createdAt
    updatedAt
    isSampleQuestion
    assignees {
      _id
      firstName
      lastName
      profileImage
      userName
  }
  enquiryCategories {
       hoverCategoryColor
                    createdBy
                    companyId
                    categoryColor
                    _id
                    name
                    textColor
  }
    addedToRegistry
    lockedTime
    boardStatus
    announcementInfo {
      announcementId
      announcementTitle
      attachment
      attachmentTitle
      pageNumber
      attachmentSize
      attachmentDuration
    }
    enquiryResponse {
      _id
      attachments
      content
      enquiryId
      rating
      title
    }
    investor {
      _id
      email
      firstName
      investorStatus
      lastName
      mobileNum
      userName
      profileImage
    }
    isDeletedInvestor
    isRemovedCompany
    isGuest
    investorId
    question
    rating
    resolvedBy
    status
    subject
  }
}`;
const createEnquiryCategory = `mutation CreateEnquiryCategory($enquiryCategoryInput: CreateEnquiryCategoryInput!) {
  createEnquiryCategory(enquiryCategoryInput: $enquiryCategoryInput) {
    _id
    createdBy
    companyId
    name
  }
}`;
const updateEnquiryCategory = `mutation UpdateEnquiryCategory($enquiryCategoryInput: EditEnquiryCategory!) {
  updateEnquiryCategory(enquiryCategoryInput: $enquiryCategoryInput) {
    _id
    companyId
    createdBy
    name
  }
}`;
const resolveEnquiry = `mutation ResolveEnquiries($resolveEnquiriesInput: ResolveEnquiriesInput!) {
  resolveEnquiries(resolveEnquiriesInput: $resolveEnquiriesInput) {
    message
  }
}`;
const enquiryResponse = `mutation AddEnquiryResponse($enquiryResponseInput: EnquiryResponseInput!) {
  addEnquiryResponse(enquiryResponseInput: $enquiryResponseInput) {
    _id
    attachments
    enquiryId
    content
    rating
    title
  }
}`;
const uploadEnquiryResponseFile = `mutation Mutation($file: Upload!) {
  uploadEnquiryResponseFile(file: $file) {
    key
  }
}`;
const hardDeleteResponseTemplate = `mutation HardDeleteResponseTemplate($responseTemplateDeleteInput: ResponseTemplateDeleteInput!) {
  hardDeleteResponseTemplate(responseTemplateDeleteInput: $responseTemplateDeleteInput) {
    message
  }
}`;
const createEvent = `mutation CreateCompanyEvent($eventInput: CompanyEventInput!) {
  createCompanyEvent(eventInput: $eventInput) {
    _id
    allDay
    attachment
    companyId
    date
    deleted
    description
    endTime
    eventAttendies
    eventSeenBy {
      investorId
      seenAt
    }
    isHoliday
    location
    publishedDate
    startTime
    title
    userId
  }
}`;
const getEvents = `query Items($eventsListInput: EventListInput!) {
  getCompanyEvents(eventsListInput: $eventsListInput) {
    items {
      _id
      attachment
      allDay
      companyId
      date
      endDate
      deleted
      description
      eventAttendies
      isHoliday
      location
      publishedDate
      startTime
      title
      userId
      endTime
    }
    meta {
      currentPage
    }
  }
}`;
const updateEvents = `mutation UpdateCompanyEvent($eventInput: CompanyEventEditInput!) {
  updateCompanyEvent(eventInput: $eventInput) {
    _id
    allDay
    attachment
    companyId
    date
    deleted
    description
    endTime
    eventAttendies
    eventSeenBy {
      investorId
      seenAt
    }
    isHoliday
    location
    startTime
    publishedDate
    title
    userId
  }
}`;
const deleteEvent = `mutation DeleteCompanyEvent($eventInput: CompanyEventDetailInput!) {
  deleteCompanyEvent(eventInput: $eventInput) {
    _id
    allDay
    attachment
    date
    companyId
    deleted
    description
    endTime
    eventAttendies
    eventSeenBy {
      investorId
      seenAt
    }
    isHoliday
    location
    publishedDate
    startTime
    title
    userId
  }
}`;
const deleteQuestionCategory = `mutation DeleteEnquiryCategory($enquiryCategory: EnquiryCategoryDeleteInput!) {
  deleteEnquiryCategory(enquiryCategory: $enquiryCategory) {
    _id
    companyId
    createdBy
    name
  }
}`;
const uploadFeebackAttachment = `mutation UploadFeebackAttachment($file: Upload!) {
  uploadFeebackAttachment(file: $file) {
    key
  }
}`;
const submitFeedback = `mutation SubmitFeedback($feedbackInput: FeedBackCreateInput!) {
  submitFeedback(feedbackInput: $feedbackInput) {
    _id
    attachment
    description
    title
  }
}`;
const getNotifcations = `query GetNotifications($notificationListInput: NotificationListInput!, $teamMembersListInput: TeamMemberListInput!) {
  getNotifications(notificationListInput: $notificationListInput) {
    items {
      _id
      companyId
      hasRead
      investorId
      message
      metaData {
        announcementId
        companyId
        enquiryId
        eventId
        enquiryResponseId
        userId
      }
      notificationType
      title
      userId
      createdAt
      userObject {
        _id
        jobTitle
        profileImage
        userName
      }
    }
    meta {
      currentPage
      itemCount
      itemsPerPage
      totalItems
      totalPages
    }
    isAllread
  }
  getTeamMembers(teamMembersListInput: $teamMembersListInput) {
    items {
      teamMember {
        _id
        userName
        jobTitle
      }
    }
  }
}`;
const getTeamMembersWithQuestionPermission = `query GetTeamMembersWithQuestionPermission($teamMembersListInput: TeamMemberListInput!) {
  getTeamMembersWithQuestionPermission(teamMembersListInput: $teamMembersListInput) {
    _id
    lastName
    userName
    firstName
    companyCreator
  }
}`;
const getEnquiryCategories = `query GetEnquiryCategories($enquiryCategoryListInput: EnquiryCategoryListInput!) {
  getEnquiryCategories(enquiryCategoryListInput: $enquiryCategoryListInput) {
    items {
          hoverCategoryColor
                    createdBy
                    companyId
                    categoryColor
                    hoverCategoryColor
                    _id
                    name
                    textColor
    }
    meta {
      totalPages
      totalItems
      itemCount
      currentPage
      itemsPerPage
    }
  }
}`;
const getPage = `query GetPage($body: PageSlugInput!) {
  getPage(body: $body) {
    _id
    content
    slug
    title
  }
}`;
const getExecutiveMembers = `query GetExecutiveMembers($body: CompanyIdInput!) {
  getExecutiveMembers(body: $body) {
    _id
    digitalPicture
    name
    role
    linkedIn
  }
}`;
const addExecutiveMember = `mutation AddExecutiveMember($body: AddExecutiveMemberInput!) {
  addExecutiveMember(body: $body) {
    _id
    digitalPicture
    name
    role
    linkedIn
  }
}`;
const uploadExeutiveMemberDP = `mutation UploadExecutiveMemberDP($file: Upload!) {
  uploadExecutiveMemberDP(file: $file) {
    attachmentDuration
    key
    thumbnailKey
  }
}`;
const deleteExecutiveTeam = `mutation DeleteExecutiveMember($body: ExecutiveMemberIdInput!) {
  deleteExecutiveMember(body: $body) {
    status
  }
}`;
const updateExecutiveTeam = `mutation EditExecutiveMember($body: EditExecutiveMemberInput!) {
  editExecutiveMember(body: $body) {
    _id
    digitalPicture
    role
    name
    linkedIn
  }
}`;
const uploadEnquiryReplyFile = `mutation UploadEnquiryReplyFile($file: Upload!) {
  uploadEnquiryReplyFile(file: $file) {
    key
  }
}`;
const getEventDetail = `query GetCompanyEvent($eventInput: CompanyEventDetailInput!) {
  getCompanyEvent(eventInput: $eventInput) {
    _id
    attachment
    allDay
    companyId
    date
    deleted
    description
    endTime
    eventAttendies
    eventSeenBy {
      investorId
      seenAt
    }
    isHoliday
    location
    publishedDate
    startTime
    title
    userId
  }
}`;
export {
    announcementList,
    companyQuery,
    dashboardQuery,
    faqQuery,
    forgotPasswordQuery,
    getCompanyDetails,
    getImage,
    googleLoginQuery,
    loggedInUserQuery,
    loginQuery,
    questionsQuery,
    registerCompanyQuery,
    resetPasswordQuery,
    registerQuery,
    starAnnouncement,
    updateProfileQuery,
    verifyQuery,
    updateProfilePicture,
    uploadCompanyLogo,
    updateCompanyQuery,
    uploadAnnouncementFile,
    createAnnouncements,
    softDeleteAnnouncements,
    updateAnnouncementDetail,
    deleteAnouncement,
    getAnnouncementDetail,
    getActivities,
    sendContactMessage,
    getResponseTemplatesList,
    getLastOtpSent,
    starResponseTemplate,
    createResponseTemplate,
    uploadTemplateFile,
    updateResponseTemplate,
    getEnquiryDetail,
    createEnquiryCategory,
    updateEnquiryCategory,
    resolveEnquiry,
    enquiryResponse,
    uploadEnquiryResponseFile,
    hardDeleteResponseTemplate,
    createEvent,
    getEvents,
    updateEvents,
    deleteEvent,
    deleteQuestionCategory,
    uploadFeebackAttachment,
    submitFeedback,
    getNotifcations,
    getTeamMembersWithQuestionPermission,
    getEnquiryCategories,
    getPage,
    getExecutiveMembers,
    addExecutiveMember,
    uploadExeutiveMemberDP,
    deleteExecutiveTeam,
    updateExecutiveTeam,
    getEventDetail,
    dashboardQuery2,
    updateCompanyLogoQuery,
    updateProfileImage,
    uploadEnquiryReplyFile
};
